
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Usuario } from "../../../shared/models/usuario.model";
import { SeguridadGateway } from "../../model/seguridad/gateway/seguridad-gateway";


@Injectable({
    providedIn: 'root'
})  
export class SeguridadUseCase {

    constructor(private readonly _seguridadGateway: SeguridadGateway) { }

    public login(urlInicio: string) : Observable<any> {
        return this._seguridadGateway.login(urlInicio);
    }

    public checkLogin() : Observable<boolean> {
        return this._seguridadGateway.checkLogin();
    }

    public datosUsuarioLogueado() : Observable<Usuario> {
        return this._seguridadGateway.datosUsuarioLogueado();
    }

    public cerrarSesion() {
        return this._seguridadGateway.cerrarSesion();
    }
}

